import { CALL_API } from '../middleware/api'

export const SUBURBS_REQUEST = 'SUBURBS_REQUEST'
export const SUBURBS_SUCCESS = 'SUBURBS_SUCCESS'
export const SUBURBS_FAILURE = 'SUBURBS_FAILURE'

export const loadSuburbs = (stateName) => (dispatch, getState) => {
	const suburbs = getState().suburbs;
	const now = Math.floor(Date.now() / 1000) // JS dates are in milliseconds!
	if (stateName === '' || (suburbs && suburbs.expires >= now)) {
		return null
	}
	
	return dispatch({
		[CALL_API]: {
			types: [SUBURBS_REQUEST, SUBURBS_SUCCESS, SUBURBS_FAILURE],
			endpoint: '/suburbs/',
			method: 'GET',
			params: {
				state: stateName
			},
			bad_response: 'Error fetching suburbs from U-MAS database'
		}
	});
}